import { gql } from '@apollo/client';

/**
 * Fragment canónico de Communication — superset de los subselects usados por
 * las mutations legacy (CREATE_NEW_COMMUNICATION, UPDATE_COMMUNICATION).
 *
 * Se usa en la respuesta de `SAVE_COMMUNICATION`. Ver
 * PLAN-SAVE-ENTITY-UNIFIED.md §2.4.
 * Communication NO tiene teams (ver schema Prisma).
 */
export const NEW_COMMUNICATION = gql`
  fragment NewCommunication on Communication {
    id

    # ─── Índices + estado ───
    indexExpedition
    indexType
    state

    # ─── Tipo C exclusivos Communication ───
    sendStatus
    interlocutorGroupIDs
    mediaOfCommunicationIDs

    # ─── Tipo B denormalizado (coherente con Order paralela; sin teams) ───
    concessionIDs
    roadIDs
    pkInitKm
    pkInitMeter
    pkEndKm
    pkEndMeter
    track
    direction
    margin
    lane
    predefinedOrderIDs
    creationDate
    registerInitDate

    # ─── Nav Trabajo/Revisión — contenedor D0 denormalizado (Fase 4 nav,
    # follow-up T4 2026-07-12): "Origen" de la tabla global de Comunicacions
    # se lee directo de este campo, sin lookup client-side por fila. Ver
    # gql/selectors/communications.ts → selectCommunicationOrders.
    containerType

    # ─── Entidad doble ───
    orderIDs
  }
`;
